import React from "react";
import { DetalleOT, EvidenciaImg } from "../../types/ot.types";
import { FileUploaderPreview } from "../FileUploaderPreview";
import { ModalEvidenciasCierre } from "../ModalEvidenciasCierre";
import { countEvidenciasCierre } from "../../utils/otDateValidation";

interface Step9Props {
  imagenesEntrega: EvidenciaImg[];
  setImagenesEntrega: React.Dispatch<React.SetStateAction<EvidenciaImg[]>>;
  detallesOT: DetalleOT[];
  evidenciasCierre: Record<number, EvidenciaImg[]>;
  setEvidenciasCierre: React.Dispatch<
    React.SetStateAction<Record<number, EvidenciaImg[]>>
  >;
  showModalEvidenciasCierre: boolean;
  setShowModalEvidenciasCierre: (val: boolean) => void;
  evaluacionTaller: {
    diagnostico: number;
    reparacion_efectiva: number;
    puntualidad: number;
    comunicacion: number;
    trabajos_completados: number;
    facturacion_rapida: number;
    garantia: number;
    comentarios: string;
  };
  setEvaluacionTaller: React.Dispatch<
    React.SetStateAction<{
      diagnostico: number;
      reparacion_efectiva: number;
      puntualidad: number;
      comunicacion: number;
      trabajos_completados: number;
      facturacion_rapida: number;
      garantia: number;
      comentarios: string;
    }>
  >;
  isCompleted?: boolean;
  fechaEntregaFormAppointment: string;
  fechaTerminacionFormAppointment?: string;
  setFechaEntregaFormAppointment: (val: string) => void;
  setFechaTerminacionFormAppointment: (val: string) => void;
  minFechaTerminacion?: string;
  minFechaEntrega?: string;
}

export const Step9Entrega: React.FC<Step9Props> = ({
  imagenesEntrega,
  setImagenesEntrega,
  detallesOT,
  evidenciasCierre,
  setEvidenciasCierre,
  showModalEvidenciasCierre,
  setShowModalEvidenciasCierre,
  evaluacionTaller,
  setEvaluacionTaller,
  isCompleted = false,
  fechaEntregaFormAppointment,
  setFechaEntregaFormAppointment,
  fechaTerminacionFormAppointment,
  setFechaTerminacionFormAppointment,
  minFechaTerminacion,
  minFechaEntrega,
}) => {
  const totalCierre = countEvidenciasCierre(evidenciasCierre);
  const cierrePendiente = totalCierre === 0 && !isCompleted;

  const handleStarClick = (
    key: keyof typeof evaluacionTaller,
    rating: number,
  ) => {
    if (!isCompleted) {
      setEvaluacionTaller((prev) => ({ ...prev, [key]: rating }));
    }
  };

  return (
    <div className="row g-4 text-start">
      <div className="col-12 mb-2">
        <div className="border rounded px-4 py-3 text-muted small">
          <i className="fas fa-flag-checkered me-2 text-primary"></i>
          Para finalizar la Orden de Trabajo, adjunte el acta de entrega o
          fotografías del bien reparado, y evalúe el servicio brindado por el
          taller.
        </div>
      </div>

      <div className="col-12">
        <div className="d-flex flex-wrap align-items-center gap-3 mb-2">
          <button
            type="button"
            className={`btn btn-sm ${cierrePendiente ? "btn-outline-danger" : "btn-outline-success"}`}
            onClick={() => setShowModalEvidenciasCierre(true)}
            disabled={isCompleted}
          >
            <i className="fas fa-camera me-1"></i>
            Cargar evidencia de reparación complementaria
          </button>
          {cierrePendiente ? (
            <span className="badge bg-danger">
              Pendiente — sin evidencia de cierre de reparación
            </span>
          ) : (
            <span className="badge bg-success">
              {totalCierre} evidencia(s) de cierre cargada(s)
            </span>
          )}
        </div>
      </div>

      <ModalEvidenciasCierre
        show={showModalEvidenciasCierre}
        onClose={() => setShowModalEvidenciasCierre(false)}
        detallesOT={detallesOT}
        evidenciasCierre={evidenciasCierre}
        setEvidenciasCierre={setEvidenciasCierre}
        title="Evidencia de reparación complementaria"
        saveLabel="Listo"
        onSave={() => setShowModalEvidenciasCierre(false)}
      />

      <div className="col-md-6">
        <div className="card shadow-none border border-secondary border-opacity-25 h-100">
          <div className="card-header py-3 border-bottom-0">
            <h6 className="fw-bold mb-0">Evidencia de Entrega</h6>
          </div>
          <div className="card-body pt-0 px-4 pb-4">
            <div id="ot-step9-fechas">
              <div className="form-group">
                <label className="fw-bold mb-1">
                  Fecha de terminación de servicio en taller
                {isCompleted && (
                  <span className="badge bg-success ms-2 fw-normal">
                    <i className="fas fa-check-circle"></i> Fecha de terminación registrada
                  </span>
                )}
              </label>
              <input
                type="datetime-local"
                className={`form-control shadow-sm ${isCompleted ? 'text-muted border-success' : ''}`}
                value={(fechaTerminacionFormAppointment || "")}
                onChange={(e) => setFechaTerminacionFormAppointment(e.target.value)}
                disabled={isCompleted}
                min={minFechaTerminacion}
              />
            </div>
            <div className="form-group">
              <label className="fw-bold mb-1">
                Fecha de entrega de unidad
                {isCompleted && (
                  <span className="badge bg-success ms-2 fw-normal">
                    <i className="fas fa-check-circle"></i> Entrega Registrada
                  </span>
                )}
              </label>
              <input
                type="datetime-local"
                className={`form-control shadow-sm ${isCompleted ? 'text-muted border-success' : ''}`}
                value={(fechaEntregaFormAppointment || "")}
                onChange={(e) => setFechaEntregaFormAppointment(e.target.value)}
                disabled={isCompleted}
                min={minFechaEntrega}
              />
            </div>
            </div>
            <div id="ot-step9-evidencias">
            <FileUploaderPreview
              label="Fotos del bien o Acta firmada *"
              archivos={imagenesEntrega}
              setArchivos={setImagenesEntrega}
              multiple={true}
              accept="image/*,video/mp4,application/pdf"
              disabled={isCompleted}
            />
            </div>
          </div>
        </div>
      </div>

      <div id="ot-step9-evaluacion" className="col-md-6">
        <div className="card shadow-none border border-secondary border-opacity-25 h-100">
          <div className="card-header py-3 border-bottom-0">
            <h6 className="fw-bold mb-0">
              Evaluación del Servicio del Taller
            </h6>
          </div>
          <div
            className="card-body pt-0 pb-4 px-4 d-flex flex-column"
            style={{ maxHeight: "100vh", height: "auto", overflowY: "auto" }}
          >
            <label className="fw-bold small mb-1">
              Diagnóstico preciso *
            </label>
            <p className="text-muted mb-1" style={{ fontSize: "0.75rem" }}>
              Identifican bien el problema desde el inicio.
            </p>
            <div className="d-flex gap-2 mb-3">
              {[1, 2, 3, 4, 5].map((star) => (
                <i
                  key={star}
                  onClick={() => handleStarClick("diagnostico", star)}
                  className={`${star <= evaluacionTaller.diagnostico ? "fas text-warning" : "far text-muted"} fa-star fs-5`}
                  style={{ cursor: isCompleted ? "default" : "pointer" }}
                ></i>
              ))}
            </div>

            <label className="fw-bold small mb-1">
              Reparaciones efectivas *
            </label>
            <p className="text-muted mb-1" style={{ fontSize: "0.75rem" }}>
              El vehículo queda bien después del servicio.
            </p>
            <div className="d-flex gap-2 mb-3">
              {[1, 2, 3, 4, 5].map((star) => (
                <i
                  key={star}
                  onClick={() => handleStarClick("reparacion_efectiva", star)}
                  className={`${star <= evaluacionTaller.reparacion_efectiva ? "fas text-warning" : "far text-muted"} fa-star fs-5`}
                  style={{ cursor: isCompleted ? "default" : "pointer" }}
                ></i>
              ))}
            </div>

            <label className="fw-bold small mb-1">
              Puntualidad *
            </label>
            <p className="text-muted mb-1" style={{ fontSize: "0.75rem" }}>
              Entregan el vehículo en el plazo prometido.
            </p>
            <div className="d-flex gap-2 mb-3">
              {[1, 2, 3, 4, 5].map((star) => (
                <i
                  key={star}
                  onClick={() => handleStarClick("puntualidad", star)}
                  className={`${star <= evaluacionTaller.puntualidad ? "fas text-warning" : "far text-muted"} fa-star fs-5`}
                  style={{ cursor: isCompleted ? "default" : "pointer" }}
                ></i>
              ))}
            </div>

            <label className="fw-bold small mb-1">
              Comunicación *
            </label>
            <p className="text-muted mb-1" style={{ fontSize: "0.75rem" }}>
              Te informan claramente, especialmente si hay demoras.
            </p>
            <div className="d-flex gap-2 mb-3">
              {[1, 2, 3, 4, 5].map((star) => (
                <i
                  key={star}
                  onClick={() => handleStarClick("comunicacion", star)}
                  className={`${star <= evaluacionTaller.comunicacion ? "fas text-warning" : "far text-muted"} fa-star fs-5`}
                  style={{ cursor: isCompleted ? "default" : "pointer" }}
                ></i>
              ))}
            </div>

            <label className="fw-bold small mb-1">
              Trabajos completados *
            </label>
            <p className="text-muted mb-1" style={{ fontSize: "0.75rem" }}>
              Se realizaron absolutamente todos los trabajos solicitados.
            </p>
            <div className="d-flex gap-2 mb-3">
              {[1, 2, 3, 4, 5].map((star) => (
                <i
                  key={star}
                  onClick={() => handleStarClick("trabajos_completados", star)}
                  className={`${star <= evaluacionTaller.trabajos_completados ? "fas text-warning" : "far text-muted"} fa-star fs-5`}
                  style={{ cursor: isCompleted ? "default" : "pointer" }}
                ></i>
              ))}
            </div>

            <label className="fw-bold small mb-1">
              Facturación rápida *
            </label>
            <p className="text-muted mb-1" style={{ fontSize: "0.75rem" }}>
              Entregan factura o comprobante a tiempo sin insistir.
            </p>
            <div className="d-flex gap-2 mb-3">
              {[1, 2, 3, 4, 5].map((star) => (
                <i
                  key={star}
                  onClick={() => handleStarClick("facturacion_rapida", star)}
                  className={`${star <= evaluacionTaller.facturacion_rapida ? "fas text-warning" : "far text-muted"} fa-star fs-5`}
                  style={{ cursor: isCompleted ? "default" : "pointer" }}
                ></i>
              ))}
            </div>

            <label className="fw-bold small mb-1">Garantía *</label>
            <p className="text-muted mb-1" style={{ fontSize: "0.75rem" }}>
              Ofrecen y respetan garantía por el trabajo realizado.
            </p>
            <div className="d-flex gap-2 mb-3">
              {[1, 2, 3, 4, 5].map((star) => (
                <i
                  key={star}
                  onClick={() => handleStarClick("garantia", star)}
                  className={`${star <= evaluacionTaller.garantia ? "fas text-warning" : "far text-muted"} fa-star fs-5`}
                  style={{ cursor: isCompleted ? "default" : "pointer" }}
                ></i>
              ))}
            </div>

            <hr className="my-2" />

            <label className="fw-bold small mb-2 mt-2">
              Comentarios Adicionales (Opcional)
            </label>
            <textarea
              className="form-control shadow-sm mb-2 flex-grow-1"
              rows={3}
              placeholder="Escriba aquí cualquier detalle adicional..."
              value={evaluacionTaller.comentarios}
              onChange={(e) =>
                setEvaluacionTaller((prev) => ({
                  ...prev,
                  comentarios: e.target.value,
                }))
              }
              disabled={isCompleted}
            ></textarea>

            {isCompleted && (
              <div className="mt-2 text-success fw-bold small text-center">
                <i className="fas fa-check-circle me-1"></i> Orden de trabajo
                cerrada y evaluada.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
